module.exports = __webpack_public_path__ + "img/te1.47d914d4.svg";